import { useQuery } from 'react-query';
import FeatureFlagsApi from '../FeatureFlagsApi';
import { FeatureFlag } from '../types';
import { featureFlagsQueryKey } from './queryKeys';

export function useFeatureFlagsQuery() {
    return useQuery<FeatureFlag[]>([featureFlagsQueryKey], () => FeatureFlagsApi.list());
}
